import { render, staticRenderFns } from "./BrandEdit.vue?vue&type=template&id=9ec713f0&scoped=true"
import script from "./BrandEdit.vue?vue&type=script&lang=js"
export * from "./BrandEdit.vue?vue&type=script&lang=js"
import style0 from "./BrandEdit.vue?vue&type=style&index=0&id=9ec713f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec713f0",
  null
  
)

export default component.exports